import { getContainmentMode } from './containmentPolicy';
import { isServer } from './general';
import { url } from './url';
import { loggedUser } from './userHelper';
import axios, { Axios } from 'axios';

let request: Axios = {} as Axios;

function setHeaders(newHeaders = {}) {
  const headers = { ...getHeaders(), ...newHeaders };
  for (const header in headers) {
    request.defaults.headers.common[header] = headers[header as keyof typeof headers];
  }
  if (isServer) {
    request.defaults.headers.common['cookie'] = 'BokadirektExperiment=1;';
  }
}

function removeHeader(header: string) {
  delete request.defaults.headers.common[header];
}
/**
 * Get instance
 */
function getInstance() {
  const axiosInstance = axios.create({ baseURL: url.getServerUrl() });
  // Lets the backend tell contained (widget) bookings apart from marketplace ones.
  // Read per request, not at module load: the embed boot may resolve the mode
  // after this module first evaluates.
  axiosInstance.interceptors.request.use((config) => {
    const embedMode = getContainmentMode();
    if (embedMode) {
      config.headers = { ...config.headers, 'x-embed-mode': embedMode };
    }
    return config;
  });

  request = axiosInstance;
  setHeaders();

  return request;
}

/**
 * Handle success
 */
function handleSuccess(response: { data: any; headers: any }) {
  const { data } = response;
  if (isServer) {
    return data;
  }
  const lastDeployTimestamp = response.headers['last-deploy-timestamp'];
  const savedLastDeployTimestamp = localStorage.getItem('last-deploy-timestamp') || 0;

  if (savedLastDeployTimestamp === 0) {
    localStorage.setItem('last-deploy-timestamp', lastDeployTimestamp);
  } else {
    if (lastDeployTimestamp && lastDeployTimestamp !== savedLastDeployTimestamp) {
      localStorage.setItem('last-deploy-timestamp', lastDeployTimestamp);
      window.location.reload();
    }
  }

  return data;
}

/**
 * Handle errors, getting an error message
 */
function handleError(error: { response?: { data?: { error?: string }; status?: number }; message: string }) {
  if (error.response) {
    if (error.response.data) {
      return Promise.reject(error.response.data.error || 'error4sentry2');
    }
  }

  return Promise.reject('error4sentry ' + error.message);
}

/**
 * Handle axios errors, getting the error object.
 */
function handleErrorObject(error: {
  response?: { data: any; status?: number };
  message?: string;
  code?: number | string;
}) {
  if (!error.response) {
    return Promise.reject({ message: error.message, code: error.code });
  }
  return Promise.reject({
    ...error.response.data,
    ...(error.response?.status ? { status: error.response.status } : {}),
  });
}

/**
 * Get Header
 */
function getHeaders() {
  const token = loggedUser();

  const headers: Record<string, string> = {};
  // User is logged in
  if (token) {
    headers['MpAuthorization'] = token;
  }
  const language = !isServer && localStorage.getItem('language') ? localStorage.getItem('language') : 'se';
  headers['Accept-Language'] = language;

  return headers;
}

getInstance();

export const server = {
  request,
  setHeaders,
  handleSuccess,
  handleError,
  handleErrorObject,
  getHeaders,
  removeHeader,
};
